import { FlatList, View, useWindowDimensions } from 'react-native';

import { styles } from './styles';
import type { GridListProps } from './types';

const GridList = <TData,>({
  getColumns = () => 2,
  itemStyle,
  ...props
}: GridListProps<TData>) => {
  const { width: screenWidth } = useWindowDimensions();

  const columns = getColumns(screenWidth);

  return (
    <FlatList
      {...props}
      key={`${props.key || 'grid-list'}-${columns}`}
      contentContainerStyle={[
        styles.contentContainer,
        props.contentContainerStyle,
      ]}
      numColumns={columns}
      renderItem={({ item, index, separators }) => (
        <View style={[itemStyle?.(columns)]}>
          {props.renderItem?.({ item, index, separators })}
        </View>
      )}
    />
  );
};

GridList.displayName = 'GridList';
export { GridList };
